import React, { ReactElement, useState } from 'react';
import './Wallet.scss';
import { WalletAcquisition } from './components/tables/WalletAcquisition';
import { WalletConsumption } from './components/tables/WalletConsumption';
import { WalletTabs } from './components/tabs/WalletTabs';
import { WalletUserInfo } from './components/userInfo/WalletUserInfo';

export const Wallet = (): ReactElement => {
  const [activeTab, setActiveTab] = useState(0);

  return (
    <div className="wallet">
      <div className="wallet__main">
        <h1 className="wallet__title">ウォレット</h1>
        <h2 className="wallet__sub-title">ダイヤ</h2>
        <WalletTabs activeTab={activeTab} setActiveTab={setActiveTab} />
        <div className="wallet__table-wrap">
          {activeTab === 0 ? <WalletAcquisition /> : <WalletConsumption />}
        </div>
      </div>
      <WalletUserInfo />
    </div>
  );
};
